import { useState } from "react";

import { useNotifications } from "../../../api/queries/notifications/notificationsQueries";
import { getLastSeenNotifications, updateLastSeenNotifications } from "../../../api/services/notifications";
import { useProfileData } from "../../../hooks/useProfileData";

export const useNotificationsHandler = () => {
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activeTab, setActiveTab] = useState("GENERAL");
  const [lastSeen, setLastSeen] = useState<number | null>(null);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useNotifications();
  const { data: userData } = useProfileData();
  const { id: userId } = userData;

  const handleOpenNotifications = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    const lastSeen = await getLastSeenNotifications();
    setLastSeen(lastSeen);
    setNotificationsOpen(true);
  };

  const handleCloseNotifications = async () => {
    setNotificationsOpen(false);
    setAnchorEl(null);
    try {
      await updateLastSeenNotifications({ userId, category: "general" });
    } catch (error) {
      console.error("Failed to update last seen notifications", error);
    }
  };

  return {
    notificationsOpen,
    anchorEl,
    activeTab,
    lastSeen,
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    setActiveTab,
    handleOpenNotifications,
    handleCloseNotifications,
  };
};
